document.querySelectorAll('[data-reader-root]').forEach((root) => {
  const fileInput = root.querySelector('[data-reader-file]');
  const intro = root.querySelector('[data-reader-intro]');
  const experience = root.querySelector('[data-reader-experience]');
  const error = root.querySelector('[data-reader-error]');
  const bookNode = root.querySelector('[data-reader-book]');
  const chapter = root.querySelector('[data-reader-chapter]');
  const title = root.querySelector('[data-reader-title]');
  const text = root.querySelector('[data-reader-text]');
  const image = root.querySelector('[data-reader-image]');
  const counter = root.querySelector('[data-reader-count]');
  const previous = root.querySelector('[data-reader-previous]');
  const next = root.querySelector('[data-reader-next]');
  let pages = [];
  let current = 0;
  let touchX = null;

  const validImage = (value) => typeof value === 'string' && /^data:image\/jpeg;base64,[A-Za-z0-9+/=]+$/.test(value);
  const validText = (value, limit) => typeof value === 'string' && value.trim().length > 0 && value.length <= limit;
  const validBook = (book) => book && book.format === 'contelune-book' && book.version === 1 &&
    validText(book.title, 150) && validText(book.subtitle, 200) && validImage(book.cover) &&
    book.dedication && validText(book.dedication.message, 700) && typeof book.dedication.signature === 'string' &&
    Array.isArray(book.spreads) && [8, 12].includes(book.spreads.length) &&
    book.spreads.every((spread) => validText(spread.text, 1600) && validImage(spread.image));

  const show = (index) => {
    current = Math.max(0, Math.min(index, pages.length - 1));
    const page = pages[current];
    chapter.textContent = page.chapter;
    title.textContent = page.title;
    text.textContent = page.text;
    image.src = page.image || '';
    image.alt = page.title;
    image.hidden = !page.image;
    previous.disabled = current === 0;
    next.disabled = current === pages.length - 1;
    counter.textContent = `${current + 1} ${root.dataset.ofLabel} ${pages.length}`;
    bookNode.style.animation = 'none';
    requestAnimationFrame(() => { bookNode.style.animation = ''; });
    if (window.matchMedia('(max-width: 760px)').matches) experience.scrollIntoView({ block: 'start', behavior: 'instant' });
  };

  fileInput.addEventListener('change', async () => {
    const file = fileInput.files && fileInput.files[0];
    if (!file) return;
    error.hidden = true;
    try {
      if (file.size > 20 * 1024 * 1024) throw new Error('size');
      const book = JSON.parse(await file.text());
      if (!validBook(book)) throw new Error('format');
      pages = [
        { chapter: root.dataset.coverLabel, title: book.title, text: book.subtitle, image: book.cover },
        { chapter: root.dataset.dedicationLabel, title: book.title, text: `${book.dedication.message}\n\n${book.dedication.signature}`, image: book.cover },
        ...book.spreads.map((spread, index) => ({ chapter: `${root.dataset.spreadLabel} ${index + 1}`, title: book.title, text: spread.text, image: spread.image })),
      ];
      intro.hidden = true;
      experience.hidden = false;
      show(0);
    } catch {
      fileInput.value = '';
      error.textContent = root.dataset.errorLabel;
      error.hidden = false;
    }
  });

  root.querySelector('[data-reader-change]').addEventListener('click', () => {
    experience.hidden = true;
    intro.hidden = false;
    fileInput.value = '';
    pages = [];
    fileInput.focus();
  });
  previous.addEventListener('click', () => show(current - 1));
  next.addEventListener('click', () => show(current + 1));
  bookNode.addEventListener('touchstart', (event) => { touchX = event.changedTouches[0]?.clientX ?? null; }, { passive: true });
  bookNode.addEventListener('touchend', (event) => {
    if (touchX === null) return;
    const delta = (event.changedTouches[0]?.clientX ?? touchX) - touchX;
    touchX = null;
    if (Math.abs(delta) > 65) show(current + (delta < 0 ? 1 : -1));
  }, { passive: true });
  document.addEventListener('keydown', (event) => {
    if (experience.hidden || !root.contains(document.activeElement) || event.altKey || event.ctrlKey || event.metaKey) return;
    if (event.key === 'ArrowRight') { event.preventDefault(); show(current + 1); }
    if (event.key === 'ArrowLeft') { event.preventDefault(); show(current - 1); }
  });
});
